import styled from "styled-components";
import Button from "./Button";
import { LesserThan } from "../icons/LesserThan";
import React from "react";
import GreaterThan from "../icons/GreaterThan";

const StyledPageSwitchButton = styled(Button)`
    background-color: transparent;
    &:hover {
        background-color: ${(props) => props.theme.color.primary.xlight};
    }
`;

export const PageSwitchButton = (props) => (
    <StyledPageSwitchButton {...props}>
        {props.left && <LesserThan />}
        {props.right && <GreaterThan />}
    </StyledPageSwitchButton>
);

export default PageSwitchButton;
